@if (benchmarkData && benchmarkData.length > 0) {
  <app-cards-basic title="{{ 'BENCHMARK.title' | translate:{ count: 0 } }}">
    <mat-chip-listbox class="statistic-selection" aria-label="Statistic selection" multiple>
      @for (benchmark of benchmarkData; track benchmark.id) {
        <mat-chip-option [selected]="selectedBenchmark.includes(benchmark.id)"
                         (click)="selectBenchmark(benchmark.id)">
          {{ benchmark.name }}
        </mat-chip-option>
      }
    </mat-chip-listbox>
  </app-cards-basic>
}
